var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:['figure', `figure--theme-${_vm.theme}`]},[(_vm.isCaptionBottom)?_vm._t("content"):_vm._e(),_vm._v(" "),_c('figcaption',{staticClass:"figure__caption",class:{'figure__caption--over': _vm.captionPosition === 'over'}},[_vm._t("caption")],2),_vm._v(" "),(_vm.isCaptionTop)?_vm._t("content"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }